export default __webpack_public_path__ + "static/media/btn_google_signin_dark_normal_web@2x.d660f455.png";